export default "__VITE_ASSET__DSAau_9L__"